import ApiClient from "../ApiClient.ts";

/**
 * idCentral is optional
 */
export async function getStops(idWorkgroup, idCentral) {
  const params = {
    wgId: idWorkgroup,
    centralId: idCentral,
  };
  try {
    const api = ApiClient();
    let response = await api.get("stops", { params });
    return response.data;
  } catch (error) {
    console.error("ERROR en getStops: ", error.message);
  }
}
